import React, { useState, useEffect } from "react";
import { Grid, Select, FormControl, MenuItem, Card } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../api";
import { useSelector } from "react-redux";
import WaterTank from "../../assets/Images/Water Leak.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  formControl: {
    width: "max-content",
    minWidth: "100%",
    backgroundColor: "#eeeef5",
    fontFamily: "Arial",
    height: "6vh",
  },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    borderRadius: "12px",
    opacity: "1",
  },
  paper1: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 0px 10px #0123B421",
    opacity: "1",
    borderRadius: "12px",
    height: "15vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1vh 0",
  },
  cardHeading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#000000",
    marginTop: "1vh",
    font: "normal normal medium 17px/60px Bw Seido Round",
    opacity: "1",
    fontWeight: "bold",
    fontSize: "1.7vh",
    textAlign: "center",
    padding: "0 0.5vw",
  },
  select: {
    fontWeight: "bold",
    height: "6vh",
    borderRadius: "0.8vw",
    fontFamily: "Arial",
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      fontSize: "2vh",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
    "& .MuiSelect-root": {
      marginTop: "-2vh",
    },
  },
}));

export default function Eqp_Details() {
  const classes = useStyles();

  const [equipmentData, setEquipmentData] = useState({});
  const [selectedDevice, setSelectedDevice] = useState("");
  const [fdata, setFdata] = useState("all");
  const zone_data = useSelector((state) => state.inDashboard.locationData);
  const [fid, setFId] = useState("all");
  const [floor, setFloor] = useState([]);
  const buildingID = useSelector((state) => state.isLogged.data.building.id);

  useEffect(() => {
    zone_data.sort((a, b) =>
      a.name > b.name ? 1 : b.name > a.name ? -1 : 0
    );

    if (fdata !== null && fdata !== "all") {
      zone_data.filter((_each) => {
        if (
          _each.zone_type === "GL_LOCATION_TYPE_FLOOR" &&
          _each.name === fdata
        ) {
          setFId(_each.uuid);
          return true;
        }
        return false;
      });
    }

    api.dashboard
      .getMetricData(buildingID)
      .then((res) => {
        const sorted = res.sort((a, b) =>
          a.name > b.name ? 1 : b.name > a.name ? -1 : 0
        );
        setFloor(sorted);
      })
      .catch((error) => console.log(error));

    api.floor.cpmGetDevData().then((res) => {
      const combinedData = {
        NONGL_SS_WLD: res["NONGL_SS_WLD"] || {},
        NONGL_SS_UPS: res["NONGL_SS_UPS"] || {},
      };
      setEquipmentData(combinedData);
      setSelectedDevice("");
    });
  }, []);

  // ─── Config Maps ─────────────────────────────────────────────────────────────

  const typeImageMap = {
    NONGL_SS_WLD: WaterTank,
    NONGL_SS_UPS: WaterTank,
  };

  const allowedParametersByType = {
    NONGL_SS_WLD: {
      WLD_S_RM: "Status",
    },
    NONGL_SS_UPS: {
      "UPS_WLD": "Status",
    },
  };

  // ─── Helpers ─────────────────────────────────────────────────────────────────

  const getDisplayName = (type, attrKey) =>
    allowedParametersByType[type]?.[attrKey] || attrKey.replace(/_/g, " ");

  const shouldShowParameter = (type, attrKey) =>
    Object.keys(allowedParametersByType[type] || {}).includes(attrKey);

  // FIX: type is passed so WLD and UPS are handled separately
  const formatValue = (type, attrKey, val) => {
    console.log(`formatValue called → type: ${type}, attrKey: ${attrKey}, val:`, val);
    if (val === null || val === undefined || val === "") return "-";

    // NONGL_SS_WLD → Normal / Leak
    if (attrKey === "UPS_WLD") {
      return val === "active" || val === 1 || val === "1" || val === true
        ? "Leak"
        : "Normal";
    }
    
        else if (attrKey === "WLD_S_RM") {
       return val === "active" || val === 1 || val === "1" || val === true
        ? "Normal"
        : "Leak";

    }
 
    

    return String(val);
  };

  

  const getAllDevices = () => {
    const allDevices = [];

    ["NONGL_SS_WLD", "NONGL_SS_UPS"].forEach((type) => {
      if (equipmentData[type]) {
        Object.entries(equipmentData[type]).forEach(([deviceId, deviceInfo]) =>
          allDevices.push({ deviceId, deviceInfo, type })
        );
      }
    });

    return allDevices.sort((a, b) =>
      a.deviceInfo.name.localeCompare(b.deviceInfo.name)
    );
  };

  const handleFloorChange = (name, id) => {
    setFId(id);
    setFdata(name);
    setSelectedDevice(id);
  };

  // ─── Render ──────────────────────────────────────────────────────────────────

  return (
    <div className={classes.root}>
      <Grid container spacing={1}>

        {/* ── Floor Dropdown ──────────────────────────────────────────────── */}
        <Grid container item xs={12} spacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={4} xl={4} style={{ marginLeft: "1vw" }}>
            <FormControl
              variant="filled"
              size="small"
              style={{ width: "max-content", minWidth: "100%", backgroundColor: "#eeeef5" }}
            >
              <Select
                labelId="floor-select-label"
                id="floor-select"
                label="Floor"
                className={classes.select}
                value={fdata}
                style={{ borderRadius: "0.8vw", height: "6vh", fontWeight: "bold" }}
                disableUnderline
              >
                <MenuItem
                  key="all-devices"
                  value="all"
                  onClick={() => handleFloorChange("all", "all")}
                >
                  All Floors
                </MenuItem>
                {floor.map((_item) => (
                  <MenuItem
                    key={_item.name}
                    value={_item.name}
                    onClick={() => handleFloorChange(_item.name, _item.id)}
                  >
                    {_item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        {/* ── Device Cards ─────────────────────────────────────────────────── */}
        <Grid container item xs={12} spacing={2} style={{ marginTop: "2vh" }}>
          {getAllDevices()
            .filter(({ deviceInfo }) =>
              fid === "all" ? true : deviceInfo?.Equipment_Group === fid
            )
            .map(({ deviceId, deviceInfo, type }) => {
              const filteredAttributes = deviceInfo?.Eqp_Attributes
                ? Object.entries(deviceInfo.Eqp_Attributes).filter(([attrKey]) =>
                    shouldShowParameter(type, attrKey)
                  )
                : [];
console.log(getAllDevices()
            .filter(({ deviceInfo }) =>
              fid === "all" ? true : deviceInfo?.Equipment_Group === fid
            ),"filteredAttributes");

              return (
                // FIX: key uses type + deviceId to avoid duplicate key collision
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} key={`${type}-${deviceId}`}>
                  <Card className={classes.paper} style={{ height: "44vh" }}>

                    {/* Device name */}
                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>
                      <Grid item xs={6} style={{ textAlign: "left", marginLeft: "2vh" }}>
                        <div
                          style={{
                            color: "black",
                            fontWeight: "bold",
                            fontSize: "3vh",
                            marginLeft: "2vh",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            lineHeight: "1.2",
                            textAlign: "left",
                          }}
                        >
                          {deviceInfo.name}
                        </div>
                      </Grid>
                    </Grid>

                    {/* Image + Attribute cards row */}
                    <Grid container spacing={1} style={{ marginTop: "0.5vh" }}>

                      {/* Equipment image */}
                      <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                        <img
                          src={typeImageMap[type]}
                          alt={type}
                          style={{
                            width: "10vw",
                            height: "25vh",
                            objectFit: "contain",
                            marginTop: "3.5vh",
                            marginLeft: "5vh",
                          }}
                        />
                      </Grid>

                      {/* Attribute cards grid */}
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={6}
                        lg={6}
                        xl={6}
                        style={{
                          overflowY: filteredAttributes.length > 4 ? "auto" : "unset",
                          maxHeight: filteredAttributes.length > 4 ? "30vh" : "unset",
                          paddingRight: "0.5vw",
                        }}
                      >
                        <Grid container spacing={1}>
                          {filteredAttributes.map(([attrKey, attrValue]) => {
                            // FIX: pass type into formatValue
                            const formattedValue = formatValue(
                              type,
                              attrKey,
                              attrValue.presentValue
                            );

                            return (
                              <Grid item xs={6} key={attrKey}>
                                <Card className={classes.paper1}>
                                  <div className={classes.cardHeading}>
                                    {getDisplayName(type, attrKey)}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "2.5vh",
                                      color: "#0123B4",
                                      fontWeight: "bold",
                                      whiteSpace: "normal",
                                      marginBottom: "2vh",
                                      marginTop: "1.2vh",
                                      lineHeight: "1.3",
                                      textAlign: "center",
                                    }}
                                  >
                                    {formattedValue}
                                    {console.log(deviceInfo?.Eqp_Attributes,"deviceInfo in render")}
                                  </div>
                                </Card>
                              </Grid>
                            );
                          })}
                        </Grid>
                      </Grid>

                    </Grid>
                  </Card>
                </Grid>
              );
            })}
        </Grid>

      </Grid>
    </div>
  );
}